const mutations = {
    ROSTER_LOADING: (state) => {
        Vue.set(state, 'rosterStatus', 'loading');
    },
    EVENTS_SUCCESS: (state, data) => {
        state.rosterStatus = 'success';
        Vue.set(state, 'events', data);
        Vue.set(state, 'roster', []);
    },
    ROSTER_SUCCESS: (state, data) => {
        state.rosterStatus = 'success';
        Vue.set(state, 'roster', data);
    },
    ROSTER_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.rosterStatus = 'error';
        state.rosterErrors.record(errors);
    },
    CLEAR_ROSTER_ERRORS: (state) => {
        state.rosterStatus = '';
        state.rosterErrors.clear();
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
